<template>
  <RealisasiKpiKorporatForm mode="Tambah" module="Realisasi Indikator Kinerja"> </RealisasiKpiKorporatForm>
</template>

<script>
import RealisasiKpiKorporatForm from './form-realisasi';
import { onBeforeRouteLeave } from 'vue-router';
import { useStore } from 'vuex';

const RealisasiKpiKorporatAdd = {
  name: 'RealisasiKpiKorporatAdd',
  components: { RealisasiKpiKorporatForm },
  setup() {
    const store = useStore();
    onBeforeRouteLeave(() => {
      store.commit('axiosResetState');
    });
  },
};

export default RealisasiKpiKorporatAdd;
</script>
